<template>
  <div id="app">
    <div class="wrap-banner">
      <div class="main-title">
        <h2>SmartGeoHub</h2>
        <!-- <p class="subtitle">
          If you see this page, the nginx web server is successfully installed
          and working. <br /> Further configuration is required.
        </p>
        <br />
        <br />
        <p class="subtitle">Thank you for using nginx</p> -->
      </div>
      <vue-particles
        color="#ffffff"
        :particleOpacity="0.7"
        linesColor="#ffffff"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="5"
        :linesWidth="2"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
*,
:after,
:before {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  overflow: hidden;
}

body {
  margin: 0;
  background: #34393f;
}

#app {
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}

.particles-js {
  background-image: url("./assets/sky.jpg");
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.wrap-banner {
  position: relative;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-flex;
  display: flex;
  height: 100%;
  justify-content: center;
}

.main-title {
  color: #fff;
  z-index: 999;

  h2 {
    font-size: 7rem;
    font-family: "Teko", sans-serif;
    text-shadow: 8px 8px #000000;
    margin: 0;
    @media (max-width: 767px) {
      font-size: 3rem;
    }
  }
  p.subtitle {
    font-size: 1.7rem;
    margin: 0;
    @media (max-width: 767px) {
      font-size: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?6b9d54d6